import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 47000-47999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const statusErrors = {
  // 47xxx statusList.
  STATUS_NOT_FOUND: {
    errorCode: 47001,
    errorMessage: t("The selected status does not exist"),
    isDynamic: false,
  },
  CLASH_STATUS_IN_USE: {
    errorCode: 47002,
    errorMessage: t("The clash status is being used"),
    isDynamic: false,
  },
  STATUS_SYSTEM_GENERATED_NOT_DELETABLE: {
    errorCode: 47003,
    errorMessage: t("The selected status is system generated and can not be deleted"),
    isDynamic: false,
  },
  STATUS_NAME_AVAILABLE: {
    errorCode: 47004,
    errorMessage: t("{{name}} status is available"),
    isDynamic: true,
    dynamicParams: ["name"],
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
